export const CARGAR_GENERAL="load_shop_configs";
export const CARGAR_CATEGORIAS="load_shop_categories";
export const CARGANDO="shop_loading";
export const ERROR="shop_error";
